import { AgendaDatesRoot, DayItem, DayText } from './styles';

import { AgendaDays } from '@pages/Agenda/helper';
import { extractSearchParams } from '@utils/fn';
import { useMobileWidth } from '@utils/hooks';
import { formatDate } from '@utils/time';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

interface AgendaDatesProps {
  agendaDaysFormat: string[];
  activeDay: string;
  color?: string;
}

const AgendaDates = ({
  agendaDaysFormat,
  activeDay,
  color,
}: AgendaDatesProps) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isHovered, setIsHovered] = useState<number | null>();
  const isMobile = useMobileWidth();

  return (
    <section>
      <AgendaDatesRoot $color={color}>
        {agendaDaysFormat?.map((e, index) => (
          <DayItem
            key={e}
            $active={e === activeDay}
            $isLastItem={index === agendaDaysFormat?.length - 1}
            $isFirstItem={index === 0}
            $color={color}
            onMouseOver={() => {
              setIsHovered(index);
            }}
            onMouseOut={() => {
              setIsHovered(null);
            }}
            onClick={() => {
              setSearchParams({
                ...extractSearchParams(searchParams),
                day: e,
              });
            }}
          >
            <DayText
              $active={e === activeDay}
              $isHovered={isHovered === index}
              $color={color}
            >
              {agendaDaysFormat?.length === 1 ? (
                <time dateTime={e}>
                  {dayjs(formatDate(e)).format('DD.MM.YYYY')}
                </time>
              ) : (
                <div>
                  <span>{`${t(AgendaDays[index])}`}</span>
                  <span>{`${isMobile ? '' : ' | '} ${dayjs(formatDate(e)).format('DD.MM.YYYY')}`}</span>
                </div>
              )}
            </DayText>
          </DayItem>
        ))}
      </AgendaDatesRoot>
    </section>
  );
};

export default AgendaDates;
